import { all, call, put, takeLatest } from 'redux-saga/effects';

import { FetchWithErrorsQuery, graphqlQueryWithErrors } from '../graphql';
import {
  getPortfolio,
  setPortfolio,
  setPortfolioError,
} from './portfolioSlice';
import { GET_PORTFOLIO } from './query';

import { waitForToken } from '../utils/utilsSagas';

export function* fetchPortfolio() {
  yield call(waitForToken);

  const response: FetchWithErrorsQuery = yield call(graphqlQueryWithErrors, {
    query: GET_PORTFOLIO,
    fetchPolicy: 'no-cache',
  });

  const { data, errors, runtimeError } = response;

  if (errors || runtimeError) {
    yield put(setPortfolioError(runtimeError ?? errors));
    return;
  }

  if (data?.getPortfolio) {
    yield put(setPortfolio(data.getPortfolio));
  }
}

export function* watchPortfolio() {
  yield all([takeLatest(getPortfolio.type, fetchPortfolio)]);
}
